import React, { useState } from 'react';
import TabBar from '../../../component/tab-bar/tab-bar';
import { ProfessorPollTab } from './tabs/poll/professor-poll-tab';

const tabs = ['משובי מרצים' /*, 'שרותים', 'היסטוריית רכישות'*/];
export const ProfessorPolls = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const onTabSelected = (index: number) => {
    setSelectedIndex(index);
  };

  const elementTabs = [<ProfessorPollTab />];
  return (
    <div className={'studies-settings-root'}>
      <div style={{ width: '100%' }} className={'studies-settings-body-page'}>
        <div className={'studies-settings-title'}>
          הגדרות מערכת - משובים למרצים
        </div>

        <TabBar
          tabs={tabs}
          onClick={(index) => {
            onTabSelected(index);
            console.log('The index ' + index + 'Is clicked');
          }}
        ></TabBar>

        {elementTabs[selectedIndex]}
      </div>
    </div>
  );
};
